module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8679/img/global.svg"